import React from "react";
import { IonItem, IonLabel, IonAccordion } from "@ionic/react";

export interface Props {}

const GettingStarted: React.FC<Props> = () => {
  return (
    <IonAccordion value="GettingStarted">
      <IonItem slot="header" color="light">
        <IonLabel>Getting Started</IonLabel>
      </IonItem>
      <div className="ion-padding" slot="content">
        <p>
          Once the tv(s) are on your Chromecast channel and your app is on the
          same wi-fi signal, you can login and start the simple three-step
          process:
        </p>
        <ol>
          <li>
            Cast &ndash; use the red casting button to transmit your quiz onto
            your screen(s). An introductory cycle will play whilst the team
            registrations occur.
          </li>
          <li>
            Register Teams &ndash; click on ‘Add Team’ &ndash; for teams who
            have played a Qwizard event simply start typing the team name, then
            click on the team from the list, record their player count and click
            &lsquo;Confirm&rsquo;. Also check their email address. For new teams
            (as identified on their Playbook registration page) select the
            &lsquo;Register New Team&rsquo; box, then add the team name, the
            team numbers and their email address (if provided).
          </li>
          <li>
            Start Quiz &ndash; once your teams are registered, select
            &lsquo;Start Quiz&rsquo; to disrupt the introductory cycle. An
            introductory screen will be shown. Use the &lsquo;Next&rsquo; button
            to progress your quiz.
          </li>
        </ol>
        <p>
          Note: you can add background Music during this registration phase by
          using the Music icon on the app
        </p>
      </div>
    </IonAccordion>
  );
};

export default GettingStarted;
